import axios from "@/api/axios";

const revenueDivision = (data) => {
    return axios
        .post('/admin/report/revenue-division', {report: data})
        .then(response => response.data)
}

const salesPlanfact = (data) => {
    return axios
        .post('/admin/report/sales-planfact', {report: data})
        .then(response => response.data)
}

export default {
    revenueDivision,
    salesPlanfact
}